class MFRBundledProduct {
    constructor( index, element ) {
        this.$index = index;
        this.$element = $( element )

        this.$addData = this.$element.data( "mfr-bundle-add" );
        this.$removeData = this.$element.data( "mfr-bundle-remove" );

        this.init()
    }

    init() {
        if( !this.$addData && !this.$removeData ) return;

        this.$element.on( "click", this.__handleClick.bind( this ) );
    }

    __handleClick( e ) {
        if( this.$addData ) this.addProductsToCart( this.$addData )
        else this.removeProductsFromCart( this.$removeData );
    }

    addProductsToCart( bundle ) {
        const id = this.generateID();
        const data = bundle;

        const payload = this.generateAddPayload( id, data );
        
        if( CartJS ) {
            if( CartJS.addItems ) {
                CartJS.addItems(payload);
            }
        }
    }

    generateAddPayload( id, data ) {
        /**
         * Sample Payload should be like this
         * {
         *      id: 12345678,
         *      quantity: 3,
         *      properties: {
         *      "size": "XL"
         *      }
         *  }
         */

        const payloadARR = [];

        $.each( data, ( i, e ) => {
            payloadARR.push({
                id: i,
                quantity: e.quantity,
                properties: {
                    "_bundle_hash": id,
                    "_added_by": "MFR Bundle Builder"
                }
            } );
        } );

        return payloadARR;
    }

    generateID() {
        return "mfr-bundle-" + Math.floor(Date.now() / 1000).toString(16) + Math.random().toString(16).substr(2, 8);
    }
}